export const isHtmlContent = (content: string) => /<\/?[a-z][\s\S]*>/i.test(content);

export const isRichTextEmpty = (html: string) =>
  !html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();

export const toEditorContent = (content: string) => {
  if (!content) return '';
  if (isHtmlContent(content)) return content;
  return content
    .split(/\n{2,}/)
    .map((paragraph) => `<p>${paragraph.replace(/\n/g, '<br>')}</p>`)
    .join('');
};

export const richTextProseClassName =
  'prose prose-sm max-w-none text-gray-700 leading-relaxed ' +
  '[&_ul]:list-disc [&_ul]:ml-6 [&_ul]:space-y-1 ' +
  '[&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:space-y-1 ' +
  '[&_li]:mb-1 ' +
  '[&_h1]:text-xl [&_h1]:font-bold [&_h1]:mb-3 [&_h1]:mt-4 ' +
  '[&_h2]:text-lg [&_h2]:font-bold [&_h2]:mb-2 [&_h2]:mt-3 ' +
  '[&_h3]:text-base [&_h3]:font-bold [&_h3]:mb-2 [&_h3]:mt-2 ' +
  '[&_p]:mb-3 ' +
  '[&_a]:text-blue-600 [&_a]:underline [&_a]:hover:text-blue-800 ' +
  '[&_strong]:font-bold [&_em]:italic [&_u]:underline';
